import { styled } from '@linaria/react';

export const Section = styled.section`
	display: flex;
	flex-direction: column;
	gap: 0.8rem;
`;
